import { SET_HOME } from "../ActionTypes";

export const setHome = data => dispatch => {
    dispatch({
        type : SET_HOME,
        payload : data
    })
}